// extracted by mini-css-extract-plugin
export default {"main__layout":"onboarding_main__layout__yM-Gc","layout__body":"onboarding_layout__body__wBFEu","layout__outlet":"onboarding_layout__outlet__uJwb8"};